import { createSlice } from '@reduxjs/toolkit';
import { ScanningMode } from '../../utils/typesAndMaps';

export interface GeneralStates {
  cameraState: boolean;
  settingsToggle: boolean;
  decodingMode: boolean; // if "true", mean Multi-threaded decoding.
  loadingContent: string;
  curImgIdx: number;
  scanningMode: ScanningMode;
}

const initialState: GeneralStates = {
  cameraState: false,
  settingsToggle: false,
  decodingMode: false,
  loadingContent: "",
  curImgIdx: -1, 
  scanningMode: 1
};

const generalStatesSlice = createSlice({
  name: "generaState",
  initialState,
  reducers: {
    updateState: (state, action: {
      payload: { value: boolean | string | number, stateName: keyof GeneralStates };
      type: string;
    }) => {
      const { stateName, value } = action.payload;
      (state as any)[stateName] = value;
      return state;
    },
  },
});

export const { updateState } = generalStatesSlice.actions;

export default generalStatesSlice.reducer;